import script from "./PlanTransaction.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanTransaction.vue?vue&type=script&setup=true&lang=js"

import "./PlanTransaction.vue?vue&type=style&index=0&id=95f59334&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95f59334"]])

export default __exports__